import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { withSsrMiddleware } from '@/middlewares/withMiddleware';
import Module from '@/modules/invest/subModules/fund/pages/singleFund';
import { IFundOrETF } from '@/services/apis/fund/types';
import {
  prefetchCommonQueries,
  TPrefetchQueriesReturn,
} from '@/services/utils';
import SubPageLayout from '@/layouts/SubPage';

interface IPageProps {
  data: {
    items: IFundOrETF[];
  };
}

const Page: PageComponent<typeof SubPageLayout, IPageProps> = ({ data }) => {
  const { query } = useRouter();

  const selectedFund = data.items.find(
    (item) => item.fundCode === query.fundCode
  );

  const keywords = [
    `صندوق ${selectedFund?.title}`,
    selectedFund?.fundCategory.name,
    ...(selectedFund?.spec || []),
  ].join(', ');

  const title = `صندوق سرمایه گذاری ${selectedFund?.title}`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta content={keywords} name="keywords" />
      </Head>
      <SubPageLayout
        hasCardHeaderBorder={false}
        hasPaddingX={false}
        title={title}
      >
        <Module />
      </SubPageLayout>
    </>
  );
};
export default Page;

export const getServerSideProps: GetServerSideProps = withSsrMiddleware(
  async (context: GetServerSidePropsContext) => {
    const queries: TPrefetchQueriesReturn = prefetchCommonQueries({
      context,
    });

    queries.add(['fund', 'getFunds'], {});

    const props = await queries.dehydrate();

    const data = (props.queriesData?.[0] || []) as IPageProps['data'];

    if (!data.items.find((item) => item.fundCode === context.query.fundCode)) {
      // Redirect if fundCode is invalid
      return {
        redirect: {
          destination: '/invest/fund',
          permanent: false,
        },
      };
    }

    return {
      props: {
        ...props,
        data: props.queriesData?.[0],
      },
    };
  },
  []
);
